import React, {Fragment, useEffect} from 'react';
import { Typography, Stack } from '@mui/material';

const BuildingSelector = ({buildings, selectedBuildingIndex, onBuildingSelected, allowSelection=false}) =>{


const handleClick = (index) => {
    if(allowSelection){
        //raise the building selected event for caller
        onBuildingSelected(index);
    }
};

    return (
        <Stack direction="row">
            {buildings.map((building, index) =>(
                (allowSelection || index===selectedBuildingIndex) &&
                <Typography variant="h4" color={index===selectedBuildingIndex?'white':'gray'} onClick={()=>handleClick(index)} key={index} sx={{m:2}}>
                    {building.title} 
                </Typography>
                
            ))}
        </Stack>
    );
};

export default BuildingSelector;